var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"src":require('@assets/images/idoors_logo_blue.png'),"contain":"","width":_vm.width,"aspect-ratio":"2.5"}})}
var staticRenderFns = []

export { render, staticRenderFns }